"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vault = exports.Vault = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const covered_call_vault_json_1 = __importDefault(require("../idl/covered_call_vault.json"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const types_1 = require("./../common/types");
const utils = __importStar(require("./../common/utils"));
const vaultUtils = __importStar(require("./utils"));
const instructions = __importStar(require("./instructions"));
const program_1 = require("../common/program");
const flex_1 = require("../flex/flex");
const types_2 = require("../flex/types");
const flexUtils = __importStar(require("../flex/flex-utils"));
const events_1 = require("./events");
const vaultConstants = __importStar(require("./constants"));
class Vault {
    constructor() {
        this._vaults = [];
        this._eventListeners = [];
    }
    get isInitialized() {
        return this._isInitialized;
    }
    /**
     * Anchor program instance.
      await utils.processTransaction(Program.VAULT, this._provider, tx);
     */
    get program() {
        return this._program;
    }
    get programId() {
        return this._program.programId;
    }
    /**
     * Anchor provider instance.
     */
    get provider() {
        return this._provider;
    }
    get network() {
        return this._network;
    }
    get stateAddress() {
        return this._stateAddress;
    }
    get vaultAuthority() {
        return this._vaultAuthority;
    }
    get state() {
        return this._state;
    }
    get vaults() {
        return this._vaults;
    }
    assertInitialized() {
        if (!this.isInitialized) {
            throw Error("Vault not initialized!");
        }
    }
    assertUninitialized() {
        if (this.isInitialized) {
            throw Error("Vault already initialized!");
        }
    }
    init(connection, programId, wallet, network, opts) {
        this.assertUninitialized();
        this._provider = new anchor.AnchorProvider(connection, wallet, opts);
        this._network = network;
        this._program = new anchor.Program(covered_call_vault_json_1.default, programId, this._provider);
        this._isInitialized = true;
    }
    // Wallet has to be state admin.
    async load(programId, network, connection, wallet = new types_1.DummyWallet(), opts = utils.defaultCommitment()) {
        exports.vault.init(connection, programId, wallet, network, opts);
        let [state, _stateNonce] = vaultUtils.getStateAddress();
        let [vaultAuthority, _vaultAuthorityNonce] = vaultUtils.getVaultAuthorityAddress();
        this._stateAddress = state;
        this._vaultAuthority = vaultAuthority;
        await this.updateState();
    }
    async initializeState(managementFeePercentage, yieldFeePercentage, feeRecipients) {
        if (feeRecipients.length != 2) {
            throw Error("Expect 2 fee recipients");
        }
        let tx = new web3_js_1.Transaction().add(await instructions.initializeStateIx(managementFeePercentage, yieldFeePercentage, feeRecipients));
        let txId = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
        await this.updateStateAccount();
        return txId;
    }
    async updateFeeRecipients(feeRecipients) {
        let tx = new web3_js_1.Transaction().add(await instructions.updateFeeRecipientsIx(feeRecipients));
        let txId = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
        await this.updateStateAccount();
        return txId;
    }
    async initializeVault(vaultName, underlyingMint, epochTimes, depositLimit) {
        let tx = new web3_js_1.Transaction().add(await instructions.initializeVaultIx(vaultName, underlyingMint, epochTimes, depositLimit));
        let txId = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
        await this.updateVaults();
        return txId;
    }
    async updateDepositLimit(vault, newDepositLimit) {
        let tx = new web3_js_1.Transaction().add(await instructions.updateVaultDepositLimitIx(vault, newDepositLimit));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    // strike is native integer 6 d.p
    async initializeOption(vault, strike) {
        await flex_1.flex.updateState();
        let tx = new web3_js_1.Transaction()
            .add(web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
            units: 300000,
        }))
            .add(web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 1,
        }))
            .add(await instructions.initializeOptionIx(vault, strike));
        let txId = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
        await this.updateVaults();
        return txId;
    }
    async fundVaultWallet(lamports) {
        let tx = new web3_js_1.Transaction().add(await instructions.fundVaultAuthorityIx(lamports));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    async initializeAuction(vault, bidEnd, cooldownEnd) {
        await this.updateVaults();
        let vaultInfo = this.getVault(vault);
        if (vaultInfo.option == null) {
            throw Error("Cannot initialize auction without creating an option.");
        }
        let vaultOptionTokenAccountInfo = await (0, spl_token_1.getAccount)(this._provider.connection, vaultInfo.vaultOptionTokenAccount);
        if (Number(vaultOptionTokenAccountInfo.amount) == 0) {
            throw Error("Cannot initialize auction with zero option tokens.");
        }
        let tx = new web3_js_1.Transaction();
        tx.add(await instructions.initializeAuctionIx(vault, utils.bigIntToBN(vaultOptionTokenAccountInfo.amount), vaultInfo.option.optionMint, bidEnd, cooldownEnd));
        let txId = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
        await flex_1.flex.updateState();
        return txId;
    }
    getAuctionForVault(vault) {
        let vaultInfo = this.getVault(vault);
        let auctions = flex_1.flex.getAuctionsByCreator(this.vaultAuthority);
        for (var i = 0; i < auctions.length; i++) {
            if (auctions[i].optionInfo.optionMint.equals(vaultInfo.option.optionMint)) {
                // There can only be one live auction per vault.
                return auctions[i];
            }
        }
        return null;
    }
    async cancelAuction(vault) {
        let auction = this.getAuctionForVault(vault);
        if (auction == null) {
            throw Error("Auction not found for vault");
        }
        let tx = new web3_js_1.Transaction().add(await instructions.cancelAuctionIx(vault, auction));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    async acceptAuctionBid(vault, bid) {
        let vaultInfo = this.getVault(vault);
        let auction = this.getAuctionForVault(vault);
        if (auction == null) {
            throw Error("Auction not found for vault!");
        }
        // Fine to ignore these ixs We don't support auctions for SOL
        let [preIxs, _postIxs, _keypair, bidderAuctionTokenAccountAddress] = await utils.createTokenAccountInstructions(this._provider.connection, auction.auctionTokenMint, bid.bidder, this._provider.wallet.publicKey, 0, true);
        let tx = new web3_js_1.Transaction().add(...preIxs, await instructions.acceptAuctionBidIx(vaultInfo, auction, bid, bidderAuctionTokenAccountAddress));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    async updateStateAccount() {
        try {
            this._state = (await this._program.account.state.fetch(this._stateAddress));
        }
        catch (e) {
            console.log("State account not initialized yet.");
        }
    }
    async updateState() {
        await this.updateStateAccount();
        await this.updateVaults();
        await this.updateDepositAndWithdrawalQueues();
    }
    async updateVaults() {
        // We need to update Flex option state to assign
        // options to a vault contract.
        await flex_1.flex.updateState();
        let accs = await this.program.account.vault.all();
        let vaults = await Promise.all(accs.map(async (acc) => {
            let vault = acc.account;
            let option = vault.optionMint.equals(web3_js_1.PublicKey.default)
                ? null
                : flex_1.flex.getOptionByMint(vault.optionMint, types_2.FlexOptionType.Normal);
            let vaultOptionTokenAccount = null;
            if (option != null) {
                vaultOptionTokenAccount =
                    flexUtils.getUserOptionMintTokenAccountAddress(flex_1.flex.programId, option.optionMint, this.vaultAuthority)[0];
            }
            let epochTimes = {
                startEpoch: new Date(vault.startEpoch.toNumber() * 1000),
                endDeposits: new Date(vault.endDeposits.toNumber() * 1000),
                startSettlement: new Date(vault.startSettlement.toNumber() * 1000),
                endEpoch: new Date(vault.endEpoch.toNumber() * 1000),
                epochCadence: vault.epochCadence,
            };
            return {
                address: acc.publicKey,
                vaultName: Buffer.from(vault.vaultName).toString().trim(),
                underlyingMint: vault.underlyingMint,
                redeemableMint: vault.redeemableMint,
                vaultUnderlyingTokenAccount: vault.vaultUnderlyingTokenAccount,
                vaultDepositQueueUnderlyingTokenAccount: vault.vaultDepositQueueUnderlyingTokenAccount,
                vaultWithdrawQueueRedeemableTokenAccount: vault.vaultWithdrawQueueRedeemableTokenAccount,
                depositLimit: vault.depositLimit.toNumber(),
                epochSequenceNumber: vault.epochSequenceNumber.toNumber(),
                epochTimes,
                startEpochVaultBalance: vault.startEpochVaultBalance.toNumber(),
                option,
                vaultOptionTokenAccount,
                vaultDepositQueueHeaderAddress: vault.depositQueueHeader,
                vaultWithdrawQueueHeaderAddress: vault.withdrawQueueHeader,
                depositQueue: [],
                withdrawalQueue: [],
                totalQueuedDeposits: 0,
                totalQueuedWithdrawals: 0,
            };
        }));
        this._vaults = vaults;
    }
    async exerciseOption(vault) {
        let tx = new web3_js_1.Transaction().add(await instructions.exerciseOptionIx(vault));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    async burnOption(vault) {
        let tx = new web3_js_1.Transaction().add(await instructions.burnOptionIx(vault));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    async collectCollateral(vault) {
        let tx = new web3_js_1.Transaction().add(await instructions.collectCollateralIx(vault));
        let txId = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
        await this.updateVaults();
        return txId;
    }
    async rolloverVault(vault, collectFees) {
        let remainingAccounts = [];
        let tx = new web3_js_1.Transaction();
        let vaultInfo = this.getVault(vault);
        if (collectFees) {
            for (var i = 0; i < this.state.feeRecipients.length; i++) {
                let key = this.state.feeRecipients[i].recipient;
                let associatedTokenAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.underlyingMint, key);
                remainingAccounts.push({
                    pubkey: associatedTokenAddress,
                    isSigner: false,
                    isWritable: true,
                });
                try {
                    await (0, spl_token_1.getAccount)(this._provider.connection, associatedTokenAddress);
                }
                catch (e) {
                    tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this.provider.wallet.publicKey, associatedTokenAddress, key, vaultInfo.underlyingMint));
                }
            }
        }
        tx.add(await instructions.rolloverVaultIx(vaultInfo.address, remainingAccounts));
        let txId = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
        await this.updateVaults();
        return txId;
    }
    getVault(vault) {
        for (var i = 0; i < this._vaults.length; i++) {
            if (this._vaults[i].address.equals(vault)) {
                return this._vaults[i];
            }
        }
        throw Error(`Vault does not exist: ` + vault.toString());
    }
    findNode(queueNodes, node) {
        for (var i = 0; i < queueNodes.length; i++) {
            if (queueNodes[i].publicKey.equals(node)) {
                return queueNodes[i].account;
            }
        }
        throw Error("Could not find node in list");
    }
    async updateDepositQueue(vault, queueNodes) {
        let vaultInfo = this.getVault(vault);
        let depositQueueHeaderInfo = await this._program.account.queueHeader.fetch(vaultInfo.vaultDepositQueueHeaderAddress);
        let totalDeposits = 0;
        if (depositQueueHeaderInfo.count.toNumber() == 0) {
            vaultInfo.depositQueue = [];
        }
        else {
            let depositQueue = [];
            let currNodeAddress = depositQueueHeaderInfo.head;
            while (!currNodeAddress.equals(web3_js_1.PublicKey.default)) {
                let currNodeInfo = this.findNode(queueNodes, currNodeAddress);
                totalDeposits += currNodeInfo.amount.toNumber();
                depositQueue.push({
                    address: currNodeAddress,
                    info: currNodeInfo,
                });
                currNodeAddress = currNodeInfo.nextNode;
            }
            vaultInfo.depositQueue = depositQueue;
        }
        vaultInfo.totalQueuedDeposits = totalDeposits;
    }
    async updateWithdrawalQueue(vault, queueNodes) {
        let vaultInfo = this.getVault(vault);
        let withdrawQueueHeaderInfo = await this._program.account.queueHeader.fetch(vaultInfo.vaultWithdrawQueueHeaderAddress);
        let totalWithdrawals = 0;
        if (withdrawQueueHeaderInfo.count.toNumber() == 0) {
            vaultInfo.withdrawalQueue = [];
        }
        else {
            let withdrawalQueue = [];
            let currNodeAddress = withdrawQueueHeaderInfo.head;
            while (!currNodeAddress.equals(web3_js_1.PublicKey.default)) {
                let currNodeInfo = this.findNode(queueNodes, currNodeAddress);
                withdrawalQueue.push({
                    address: currNodeAddress,
                    info: currNodeInfo,
                });
                totalWithdrawals += currNodeInfo.amount.toNumber();
                currNodeAddress = currNodeInfo.nextNode;
            }
            vaultInfo.withdrawalQueue = withdrawalQueue;
        }
        vaultInfo.totalQueuedWithdrawals = totalWithdrawals;
    }
    async updateDepositAndWithdrawalQueues() {
        let queueNodes = await this._program.account.queueNode.all();
        await Promise.all(this._vaults.map(async (vault) => {
            await this.updateDepositQueue(vault.address, queueNodes);
            await this.updateWithdrawalQueue(vault.address, queueNodes);
        }));
    }
    async processDepositQueue(vault) {
        await this.updateDepositAndWithdrawalQueues();
        let vaultInfo = this.getVault(vault);
        let depositQueue = vaultInfo.depositQueue;
        if (depositQueue.length != 0) {
            let createIxForUserAlready = [];
            for (let i = 0; i < depositQueue.length; i += vaultConstants.PROCESS_QUEUE_ACCOUNT_LIMIT) {
                let tx = new web3_js_1.Transaction();
                let remainingAccounts = [];
                let slice = depositQueue.slice(i, i + vaultConstants.PROCESS_QUEUE_ACCOUNT_LIMIT);
                for (let i = 0; i < slice.length; i++) {
                    let node = slice[i];
                    if (createIxForUserAlready.includes(node.info.userKey.toString())) {
                        return;
                    }
                    let userRedeemableTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.redeemableMint, node.info.userKey);
                    try {
                        await (0, spl_token_1.getAccount)(this._provider.connection, userRedeemableTokenAccountAddress);
                    }
                    catch (e) {
                        tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this._provider.wallet.publicKey, userRedeemableTokenAccountAddress, node.info.userKey, vaultInfo.redeemableMint));
                        createIxForUserAlready.push(node.info.userKey.toString());
                    }
                }
                for (let j = 0; j < slice.length; j++) {
                    let userRedeemableTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.redeemableMint, slice[j].info.userKey);
                    remainingAccounts.push({
                        pubkey: slice[j].address,
                        isSigner: false,
                        isWritable: true,
                    });
                    remainingAccounts.push({
                        pubkey: userRedeemableTokenAccountAddress,
                        isSigner: false,
                        isWritable: true,
                    });
                    remainingAccounts.push({
                        pubkey: slice[j].info.userKey,
                        isSigner: false,
                        isWritable: true,
                    });
                }
                tx.add(await instructions.processDepositQueueIx(vaultInfo, remainingAccounts));
                let sig = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
                console.log(`Process deposit queue TX: ${sig}`);
            }
        }
        else {
            console.log("Empty deposit queue...");
        }
    }
    async processWithdrawQueue(vault) {
        await this.updateDepositAndWithdrawalQueues();
        let vaultInfo = this.getVault(vault);
        let withdrawQueue = vaultInfo.withdrawalQueue;
        if (withdrawQueue.length != 0) {
            // We can be lazy here by not checking for redeemable token account existence
            // When we deposit vault we already check and create redeemable account for users
            let createIxForUserAlready = [];
            for (let i = 0; i < withdrawQueue.length; i += vaultConstants.PROCESS_QUEUE_ACCOUNT_LIMIT) {
                let tx = new web3_js_1.Transaction();
                let remainingAccounts = [];
                let slice = withdrawQueue.slice(i, i + vaultConstants.PROCESS_QUEUE_ACCOUNT_LIMIT);
                for (let j = 0; j < slice.length; j++) {
                    if (createIxForUserAlready.includes(slice[j].info.userKey.toString())) {
                        continue;
                    }
                    let tokenAccountKey = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.underlyingMint, slice[j].info.userKey);
                    try {
                        await (0, spl_token_1.getAccount)(this._provider.connection, tokenAccountKey);
                    }
                    catch (e) {
                        tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this._provider.wallet.publicKey, tokenAccountKey, slice[j].info.userKey, vaultInfo.underlyingMint));
                        createIxForUserAlready.push(slice[j].info.userKey.toString());
                    }
                    remainingAccounts.push({
                        pubkey: slice[j].address,
                        isSigner: false,
                        isWritable: true,
                    });
                    remainingAccounts.push({
                        pubkey: tokenAccountKey,
                        isSigner: false,
                        isWritable: true,
                    });
                    remainingAccounts.push({
                        pubkey: slice[j].info.userKey,
                        isSigner: false,
                        isWritable: true,
                    });
                }
                tx.add(await instructions.processWithdrawQueueIx(vaultInfo, remainingAccounts));
                let sig = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
                console.log(`Process withdrawal queue TX: ${sig}`);
            }
        }
        else {
            console.log("Empty withdrawal queue...");
        }
    }
    async overrideVaultEpochTimes(vault, args) {
        let tx = new web3_js_1.Transaction().add(await instructions.overrideVaultEpochTimesIx(vault, args));
        await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    subscribeUserEvents(callback = undefined) {
        if (this._eventListeners.length > 0) {
            throw Error("Events already subscribed!");
        }
        this._eventListeners.push(this._program.addEventListener(events_1.VaultEvent.DEPOSIT, (event, _slot) => {
            callback(events_1.VaultEvent.DEPOSIT, event);
        }));
        this._eventListeners.push(this._program.addEventListener(events_1.VaultEvent.WITHDRAWAL, (event, _slot) => {
            callback(events_1.VaultEvent.WITHDRAWAL, event);
        }));
    }
    async close() {
        for (var i = 0; i < this._eventListeners.length; i++) {
            await this._program.removeEventListener(this._eventListeners[i]);
        }
        this._eventListeners = [];
    }
}
exports.Vault = Vault;
exports.vault = new Vault();
